import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageSkeletonUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessageSkeleton', slot);
}
export const chatMessageSkeletonClasses = generateUtilityClasses('MuiChatMessageSkeleton', ['root', 'line']);
const slots = {
  root: ['root'],
  line: ['line']
};
export const useChatMessageSkeletonUtilityClasses = classes => composeClasses(slots, getChatMessageSkeletonUtilityClass, classes);